import React from 'react';
import PropTypes from 'prop-types';

import classes from './CountrySelector.css';
import CountrySelectorItem from './CountrySelectorItem/CountrySelectorItem';
import canadaIcon from '../../../../assets/images/canada.svg';
import usaIcon from '../../../../assets/images/usa.svg';

const countrySelector = props => {
  const {
    country,
    language,
    closeSideBar,
    selectedCanadaEN,
    selectedCanadaFR,
    selectedUSA
  } = props;

  const {
    countryTranslation
  } = require('../../../../assets/data/LocalizedStrings/LocalizedStrings.json')[
    language
  ];

  return (
    <div className={classes.CountrySelector}>
      <span className={classes.CountrySpan}>{countryTranslation}</span>
      <ul>
        <CountrySelectorItem
          closeSideBar={closeSideBar}
          optionImg={usaIcon}
          optionTitle="USA"
          selectCountry={selectedUSA}
          selectedItem={country === 'USA' && language === 'en'}
        />
        <CountrySelectorItem
          closeSideBar={closeSideBar}
          optionImg={canadaIcon}
          optionTitle="Canada (EN)"
          selectCountry={selectedCanadaEN}
          selectedItem={country === 'Canada' && language === 'en'}
        />
        <CountrySelectorItem
          closeSideBar={closeSideBar}
          optionImg={canadaIcon}
          optionTitle="Canada (FR)"
          selectCountry={selectedCanadaFR}
          selectedItem={country === 'Canada' && language === 'fr'}
        />
      </ul>
    </div>
  );
};

countrySelector.propTypes = {
  country: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  closeSideBar: PropTypes.func,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default countrySelector;
